var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('head',[_c('link',{attrs:{"rel":"stylesheet","href":_vm.css}})]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row gameplay_pg"},[_c('div',{staticClass:"iframe_section"},[_c('iframe',{attrs:{"src":'static/mini_games/puzzle_game/'+_vm.puzzleGameCss+'_gameplay.html',"frameborder":"0"}})])])]),_vm._v(" "),_c(_vm.currentModal,{tag:"component"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbc3562","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/game/addongamepuzzle/AddOnGamePuzzle.vue
// module id = null
// module chunks = 